import styles from './index.module.sass';

const PageNotFound = () => {
  return (
    <div className={styles['page-not-found']}>
      <div className={styles.icon}>
        <img src="/assets/icon_404.png" alt="404" />
      </div>
      <div className={styles.title}>找不到網頁</div>
    </div>
  );
};

export default PageNotFound;
